import { render, staticRenderFns } from "./worker-icon.vue?vue&type=template&id=40586aa9"
import script from "./worker-icon.vue?vue&type=script&lang=js"
export * from "./worker-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports